import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import api from "../../utils/Url";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ToastApp from "../../ToastApp";
import { Autocomplete, Box, Card, CircularProgress, Grid, Paper, Stack, TextField } from "@mui/material/node";
import { ConfirmDialog } from "primereact/confirmdialog";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import { toast } from "react-toastify";
import { Toast } from "react-toastify/dist/components";




export default function NoduesList() {
   

    const [applicableAcceOption, setASpplicableAcceOption] = React.useState<any>([{ value: "-1", label: ("Member Code") }]);
    console.log("🚀 ~ IssueReturn ~ applicableAcceOption:", applicableAcceOption)
 
    const [timerCheck, setTimerCheck] = React.useState<NodeJS.Timeout | null>(null);
    const [applicableAcceOptionMemName, setApplicableAcceOptionMemName] = React.useState<any>("");
    const [memberCode, setmemberCode] = React.useState("");

      const [Option, setOption] = React.useState<
    any[]
  >([]);

  const [progData, setProgData] = React.useState<string>("");

  React.useEffect(() => {
programData();
  },[])
  
    
   

    const handleInputChange = (event: any) => {

        const newQuery = event.target.value;
        console.log("newQuery", newQuery)
        if (newQuery != "") {

            console.log("newQuery 1  ", newQuery)
            if (timerCheck) {
                clearTimeout(timerCheck)
            }
            const checkResult = setTimeout(() => {
                getApplicableAccesion(newQuery);
            }, 500);
            setTimerCheck(checkResult)
        }
    }

    const getApplicableAccesion = async (nameData: any) => {

        // if (nameData.length < 3) {
        //   setTermData("");
        //   return;
        // }
        api
            .get(`AssigningRfid/GetMember?name=${nameData}`)
            .then((res) => {
                let arr: any = [];

                console.log("result" + JSON.stringify(res.data));


                const transformedData = transformData(res.data);
                setASpplicableAcceOption(transformedData);
                // for (let index = 0; index < res.data.length; index++) {
                //   arr.push({
                //     label: res.data[index]["label"],
                //     value: res.data[index]["value"]
                //   });
                // }
                // setASpplicableAcceOption(arr);
                // //setZoneOption(arr);
                // console.log(arr);
            });
    };

    const transformData = (data: any) => {
        return data.map((item: any) => {
            const name = item.label.replace(/^\(.*?\)/, '').trim();
            return {
                value: item.value,
                label: `${item.value} -- ${name} `,
                name: name
            };
        });
    };

   


    const DownloadNodues = () => {
        const collectData = {
            "mem_cd":memberCode ||  "",
            "mname": "",
            "mem_prmntphone": "",
            "mem_email": "",
            "mem_prmntadd1": "",
            "mem_prmntcity": "",
            "dept": "",
            "deptcode": "",
            "branch_cd": "",
            "branch_name": ""
        };
        api
            .post(`AssigningRfid/DownloadNoDuesPdf`, collectData)
            .then((response) => {
                  const base64Pdf = response?.data?.base64Pdf;
                if (base64Pdf) {
                    try {
                        const byteCharacters = atob(base64Pdf);
                        const byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        const byteArray = new Uint8Array(byteNumbers);
                        const blob = new Blob([byteArray], { type: "application/pdf" });

                        const link = document.createElement("a");
                        link.href = URL.createObjectURL(blob);
                        const fileName = `NoDues_${memberCode}_${new Date().toISOString().split('T')[0]}.pdf`;
                        link.download = fileName;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        URL.revokeObjectURL(link.href); // Clean up
                        // toast.succes( "PDF downloaded successfully!");
                    } catch (e) {
                        console.error("Error processing or downloading PDF:", e);
                        // ShowMessage(MessageType.Error, "Failed to process or download PDF.");
                    }
                } else {
                    toast.error(response?.data);
                }
            });
    };


     const programData = () => {
    const collectData = {
      "branch_cd": "",
      "branch_name": ""
    };
    api
      .post(`Member/Getm_prgram`, collectData)
      .then((response) => {
        if (response.data && response.data.data) {
          const arr = response.data.data.map((items: any) => ({
            label: `${items.branch_name} (${items.branch_cd})`,
            value: items.branch_cd,
          }));
          setOption(arr);
        } else {
          setOption([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching program data:", error);
        setOption([]);
      });
  };





    return (
        <div >

            <Card
                style={{
                    width: "100%",
                    backgroundColor: "#E9FDEE",
                    marginTop: "3vh",
                }}
            >
                <Paper
                    sx={{
                        width: "100%",
                        overflow: "hidden",
                        "& .MuiDataGrid-colCell": {
                            backgroundColor: "#2B4593",
                            color: "#fff",
                            fontSize: 17,
                            fontWeight: 900,
                        },
                    }}
                    style={{ padding: "10px" }}
                >
                    <ConfirmDialog />

                    <Typography
                        gutterBottom
                        variant="h5"
                        component="div"
                        sx={{ padding: "20px" }}
                        align="left"
                    >
                        No Dues List
                    </Typography>
                    <Divider />

                    <Box height={10} />

                    <Stack direction="row" spacing={2} sx={{ mb: 2, flexWrap: 'wrap' }}>
                        {/*permissionData?.isAdd == true && ( */}
                        {/* <Button
                      onClick={routeChangeAdd}
                      variant="contained"
                      endIcon={<AddCircleIcon />}
                      size="large"
                    >
                      {t("text.Add")}
                    </Button> */}
                        {/*)} */}

                        {/* {permissionData?.isPrint == true ? ( */}
                        {/* <Button variant="contained" onClick={fetchZonesData} size="large">
                        {t("text.print")}
                      </Button> */}
                        {/* ) : (
                      ""
                    )} */}
                    </Stack>

                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                options={applicableAcceOption}
                                getOptionLabel={(option: any) => `${option?.label}`}
                                fullWidth
                                size="small"
                                value={applicableAcceOptionMemName?.value}
                                onInputChange={(_:any, newInputValue: any) =>
                                    handleInputChange({ target: { value: newInputValue } } as any)
                                }
                                onChange={(e: any, newValue: any) => {
                                    console.log("🚀 ~ IssueReturn ~ newValue:", newValue);
                                    if (newValue) {
                                        setmemberCode(newValue.value);
                                    } else {
                                        setmemberCode("");
                                    }
                                    setApplicableAcceOptionMemName(newValue);
                                }}
                                renderInput={(params: any) => (
                                    <TextField
                                        {...params}
                                        label={
                                            <Typography>Select Member Code</Typography>
                                        }
                                    />
                                )}
                            />
                        </Grid>

                        




                        {/* Buttons Section */}
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <Button
                                variant="contained"
                                size="small"
                                fullWidth
                                onClick={DownloadNodues}
                            >
                                Print
                            </Button>
                        </Grid>


                    </Grid>


                </Paper>
            </Card>
            <ToastApp />

        </div>
    );
}
